import React, { Component } from 'react';
import { func, number, string, bool } from 'prop-types';
import classNames from 'classnames';
import './JobPricingSummaryTab.scss';

class JobPricingSummaryTab extends Component {
  static propTypes = {
    onClick: func,
    tabTitle: string,
    tabValue: number,
    active: bool,
    valueClassName: string
  };

  static defaultProps = {
    ...Component.defaultProps,
    active: false
  };

  constructor(props) {
    super(props);
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    e.stopPropagation();
    this.props.onClick();
  }

  render() {
    const { tabTitle, tabValue, active, valueClassName } = this.props;

    const tabClass = classNames({
      'results-tab': true,
      'results-tab__active': active
    });

    return (
      <div className={tabClass} onClick={this.onClickHandler}>
        <div className="results-tab__label">{tabTitle}</div>
        <div className={valueClassName}>{tabValue}</div>
      </div>
    );
  }
}

export default JobPricingSummaryTab;
